import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { LuMail, LuArrowLeft, LuSend } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../redux/reducers/authSlice';

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { passwordLoading } = useSelector((state) => state.auth);

    const formik = useFormik({
        initialValues: { email: '' },
        validationSchema: Yup.object({
            email: Yup.string().email('Invalid email address').required('Required'),
        }),
        onSubmit: (values) => {
            dispatch(forgotPassword(values.email)).then((res) => {
                if (res.meta.requestStatus === 'fulfilled') {
                    // Toast notification shown by the thunk
                }
            });
        },
    });

    return (
        <div className="vh-100 d-flex align-items-center justify-content-center bg-light px-3">
            <Card className="border-0 shadow-sm rounded-4 p-4 p-md-5" style={{ maxWidth: '450px', width: '100%' }}>
                <div className="text-center mb-4">
                    <div className="bg-soft-brand text-brand rounded-circle d-inline-flex p-3 mb-3">
                        <LuMail size={32} />
                    </div>
                    <h3 className="fw-bold">Forgot Password?</h3>
                    <p className="text-muted">
                        No worries! Enter the email associated with your account and we'll send a reset link.
                    </p>
                </div>

                <Form onSubmit={formik.handleSubmit}>
                    <Form.Group className="mb-4">
                        <Form.Label className="small fw-bold text-muted">Email Address</Form.Label>
                        <div className="position-relative">
                            <Form.Control
                                type="email"
                                name="email"
                                placeholder="name@company.com"
                                className={`bg-light border-0 py-3 ps-3 rounded-3 shadow-none ${formik.touched.email && formik.errors.email ? 'is-invalid' : ''}`}
                                {...formik.getFieldProps('email')}
                            />
                            {formik.touched.email && formik.errors.email && (
                                <Form.Control.Feedback type="invalid">
                                    {formik.errors.email}
                                </Form.Control.Feedback>
                            )}
                        </div>
                    </Form.Group>

                    <Button
                        variant="brand"
                        type="submit"
                        className="w-100 py-3 rounded-pill fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
                        disabled={passwordLoading}
                    >
                        {passwordLoading ? (
                            <Spinner size="sm" animation="border" />
                        ) : (
                            <>Send Reset Link <LuSend size={18} /></>
                        )}
                    </Button>
                </Form>

                <div className="text-center mt-4">
                    <Button
                        variant="link"
                        className="text-decoration-none text-muted small fw-bold d-flex align-items-center justify-content-center gap-1 mx-auto"
                        onClick={() => navigate('/login')}
                    >
                        <LuArrowLeft size={16} /> Back to Login
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default ForgotPassword;
